
import $ from 'jquery';
import Vue from 'vue';
import Component from 'vue-class-component';
import { Action, State } from 'vuex-class';

import JobSearching from '@/components/landing/JobSearching.vue';
import ModalVideo from '@/components/landing/ModalVideo.vue';

@Component({
  components: {
    JobSearching,
    ModalVideo,
  },
})
export default class FAQList extends Vue {
  /* VUEX */

  // ACTIONS
  @Action('actionSelectFAQCategory', {namespace: 'faq'})
  private actionSelectFAQCategory: any;
  @Action('actionSelectFAQByCategory', {namespace: 'faq'})
  private actionSelectFAQByCategory: any;

  // STATE
  @State('array_faq', {namespace: 'faq'})
  private array_faq: any;
  @State('array_faq_category', {namespace: 'faq'})
  private array_faq_category: any;

  /* INITIALIZATION */

  private selectedCategory: any = null;
  private videoShown: boolean = false;
  private vidioId: string = '';

  constructor() {
    super();
  }

  /* LIFECYCLE */

  private created() {
    this.actionSelectFAQCategory({listener: this.listenerCategory});
  }

  private updated() {
    Array.from($('.ToggleContent')).forEach((item) => {
      item.onclick = function () {
        if ($(this).children().first().hasClass('ArrowRight')) {
          const arrow = $(this).find('.ArrowRight');
          arrow.removeClass('ArrowRight');
          arrow.addClass('ArrowDown');
          $(this).next().show();
        } else {
          const arrow = $(this).find('.ArrowDown');
          arrow.removeClass('ArrowDown');
          arrow.addClass('ArrowRight');
          $(this).next().hide();
        }
      };
    });
  }

  /* LISTENER */

  private listenerCategory() {
    this.clickFAQ(this.array_faq_category[0]);
  }

  private listenerAction() {
    $('html, body').animate({
      scrollTop: ($('.FAQItem') as any).offset().top - 100,
    }, 500);
  }

  /* METHOD */

  private clickFAQ(category: any) {
    this.selectedCategory = category;
    if (category.name === 'Job Vacancy') {
      this.videoShown = true;
      this.vidioId = 'cQAW1p8kv_Y';
    }

    if (category.name === 'Dashboard') {
      this.videoShown = true;
      this.vidioId = 'r9YNnUKpRL0';
    }

    if (category.name === 'News') {
      this.videoShown = true;
      this.vidioId = '8ThO1gWrr4g';
    }

    if (category.name === 'Candidate') {
      this.videoShown = true;
      this.vidioId = 'h8OiBNAZuj4';
    }

    if (category.name === 'Ads') {
      this.videoShown = true;
      this.vidioId = 'bn84VhjZjcA';
    }


    // if (category) {
    //   this.actionSelectFAQByCategory({id: category.id, listener: this.listenerAction});
    // }
  }

  private clickSearch(search: string) {
    this.actionSelectFAQCategory({
      params: {search},
      listener: this.listenerCategory,
    });
  }

  private selectFAQIcon(category: any) {
    if (category.name === 'Job Vacancy') {
      if (this.selectedCategory && this.selectedCategory.id === category.id) {
        return require('@/assets/Photo/FAQ/icon_FAQ_vacancy_active.svg');
      } else {
        return require('@/assets/Photo/FAQ/icon_FAQ_vacancy_inactive.svg');
      }
    } else if (category.name === 'Dashboard') {
      if (this.selectedCategory && this.selectedCategory.id === category.id) {
        return require('@/assets/Photo/FAQ/icon_FAQ_dashboard_active.svg');
      } else {
        return require('@/assets/Photo/FAQ/icon_FAQ_dashboard_inactive.svg');
      }
    } else if (category.name === 'Candidate') {
      if (this.selectedCategory && this.selectedCategory.id === category.id) {
        return require('@/assets/Photo/FAQ/icon_FAQ_profile_active.svg');
      } else {
        return require('@/assets/Photo/FAQ/icon_FAQ_profile_inactive.svg');
      }
    } else if (category.name === 'News') {
      if (this.selectedCategory && this.selectedCategory.id === category.id) {
        return require('@/assets/Photo/FAQ/icon_FAQ_application_active.svg');
      } else {
        return require('@/assets/Photo/FAQ/icon_FAQ_application_inactive.svg');
      }
    } else if (category.name === 'Ads') {
      if (this.selectedCategory && this.selectedCategory.id === category.id) {
        return require('@/assets/Photo/FAQ/icon_FAQ_verify_active.svg');
      } else {
        return require('@/assets/Photo/FAQ/icon_FAQ_verify_inactive.svg');
      }
    } else if (category.name === 'Account Setting') {
      if (this.selectedCategory && this.selectedCategory.id === category.id) {
        return require('@/assets/Photo/FAQ/icon_FAQ_settings_active.svg');
      } else {
        return require('@/assets/Photo/FAQ/icon_FAQ_settings_inactive.svg');
      }
    }
  }
}
